import React, { useState, createContext, useContext } from 'react';
type ConsultationFormContextType = {
  showForm: boolean;
  openForm: () => void;
  closeForm: () => void;
};
const ConsultationFormContext = createContext<ConsultationFormContextType>({
  showForm: false,
  openForm: () => {},
  closeForm: () => {}
});
export function useConsultationForm() {
  return useContext(ConsultationFormContext);
}
export function ConsultationFormProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [showForm, setShowForm] = useState(false);
  return <ConsultationFormContext.Provider value={{
    showForm,
    openForm: () => setShowForm(true),
    closeForm: () => setShowForm(false)
  }} data-id="element-28">
      {children}
    </ConsultationFormContext.Provider>;
}